/**
 * Do not preventDefault on Enter — react-select CreatableSelect needs the
 * native key event to create the typed option. Form submit is blocked via
 * the parent <Form onSubmit={e => e.preventDefault()}>.
 */
export function preventEnterSubmit(event) {
  if (event.key === "Enter") {
    event.stopPropagation();
  }
}

/** Only search on real typing; keep the input value for create-on-Enter. */
export function onCreatableInputChange(onSearch) {
  return (inputValue, actionMeta) => {
    const action = actionMeta?.action;
    if (action === "input-change") {
      onSearch?.(inputValue);
      return inputValue;
    }
    if (action === "set-value" || action === "create-option") {
      onSearch?.("");
      return "";
    }
    return inputValue;
  };
}

export function formatCreateSkillLabel(input) {
  const name = String(input || "").trim();
  return name ? `Add "${name}"` : "Add skill";
}

export const creatableSkillSelectDefaults = {
  isMulti: true,
  isClearable: true,
  closeMenuOnSelect: false,
  hideSelectedOptions: false,
  createOptionPosition: "first",
  allowCreateWhileLoading: true,
  formatCreateLabel: formatCreateSkillLabel,
};
